"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@loadsure/utils");
const _1 = require(".");
class Exposure {
    constructor(data) {
        this.coverageForDomesticShipments = data.coverageForDomesticShipments;
        this.primaryDomesticShipment = data.primaryDomesticShipment;
        this.contingentDomesticShipment = data.contingentDomesticShipment;
        this.primaryInternationalShipment = data.primaryInternationalShipment;
        this.contingentInternationalShipment = data.contingentInternationalShipment;
        this.totalInternationalShipment = data.totalInternationalShipment;
        this.conveyanceSizeAndLimits = data.conveyanceSizeAndLimits;
        this.primaryCommodity = data.primaryCommodity;
        this.secondaryCommodities = data.secondaryCommodities;
        this.isTemperatureSensitive = data.isTemperatureSensitive;
        this.temperatureDesiredCoverage = data.temperatureDesiredCoverage;
        this.allGoodsBeContainerized = data.allGoodsBeContainerized;
        this.detailedPackagingDescription = data.detailedPackagingDescription;
        this.valuation = data.valuation;
        this.numberOfAnnualSales = data.numberOfAnnualSales;
        this.goodsInsuredDescription = data.goodsInsuredDescription;
        this.annualShipmentVolume = data.annualShipmentVolume;
        this.targetPremium = data.targetPremium;
        this.currentDeductible = data.currentDeductible;
        this.maximumDesiredCoverageLimit = data.maximumDesiredCoverageLimit;
        this.coverageForExhibition = data.coverageForExhibition;
        this.salespersonsSamplesCoverage = data.salespersonsSamplesCoverage;
        this.salespersonsSamplesCoverage = data.salespersonsSamplesCoverage;
        this.exhibitionCoverage = data.exhibitionCoverage;
        this.acknowledgeExcludeCommodities = data.acknowledgeExcludeCommodities;
    }
    static empty() {
        const data = {
            primaryCommodity: null,
            secondaryCommodities: [],
            isTemperatureSensitive: null,
            temperatureDesiredCoverage: null,
            allGoodsBeContainerized: null,
            detailedPackagingDescription: "",
            goodsInsuredDescription: "",
            valuation: null,
            numberOfAnnualSales: {
                currency: "USD",
                value: null
            },
            annualShipmentVolume: null,
            targetPremium: null,
            coverageForDomesticShipments: null,
            primaryDomesticShipment: null,
            contingentDomesticShipment: null,
            primaryInternationalShipment: null,
            contingentInternationalShipment: null,
            totalInternationalShipment: null,
            conveyanceSizeAndLimits: {
                vesselOrAircraft: {
                    averageValue: null,
                    maximumValue: null,
                    desiredLimit: null
                },
                oneShipment: {
                    averageValue: null,
                    maximumValue: null,
                    desiredLimit: null
                },
                truckOrRailcar: {
                    averageValue: null,
                    maximumValue: null,
                    desiredLimit: null
                },
                packageMailOrParcelPost: {
                    averageValue: null,
                    maximumValue: null,
                    desiredLimit: null
                },
                bargeOrTow: {
                    averageValue: null,
                    maximumValue: null,
                    desiredLimit: null
                }
            },
            currentDeductible: null,
            maximumDesiredCoverageLimit: null,
            coverageForExhibition: null,
            salespersonsSamplesCoverage: null,
            exhibitionCoverage: null,
            acknowledgeExcludeCommodities: null
        };
        return new Exposure(data);
    }
    static fromObj(data) {
        if (!data) {
            return Exposure.empty();
        }
        return new Exposure(Object.assign({}, data));
    }
    validateValuation(errors) {
        if (!this.valuation ||
            !Object.values(_1.eExposureValuation).includes(this.valuation))
            errors.push("Wrong valuation");
        const { numberOfAnnualSales, valuation, annualShipmentVolume } = this;
        if (valuation === _1.eExposureValuation.SELLING_PRICE &&
            (!(numberOfAnnualSales === null || numberOfAnnualSales === void 0 ? void 0 : numberOfAnnualSales.value) || numberOfAnnualSales.value < 0))
            errors.push("Wrong number of annual sales");
        if ((valuation === _1.eExposureValuation.CIF10 ||
            valuation === _1.eExposureValuation.CIF20) &&
            (!annualShipmentVolume || annualShipmentVolume < 0))
            errors.push("Wrong annual shipment volume");
        return errors;
    }
    validateExhibitionCoverage(errors) {
        if (typeof this.coverageForExhibition !== "boolean")
            errors.push("Wrong flag coverage for exhibition");
        const { coverageForExhibition, exhibitionCoverage, salespersonsSamplesCoverage } = this;
        if (coverageForExhibition) {
            if (!utils_1.isNumber(exhibitionCoverage) && exhibitionCoverage !== "N/A")
                errors.push("Wrong exhibition coverage value");
            if (!utils_1.isNumber(salespersonsSamplesCoverage) &&
                salespersonsSamplesCoverage !== "N/A")
                errors.push("Wrong salespersons samples coverage value");
        }
        return errors;
    }
    validateDomesticCoverage(errors) {
        var _a, _b, _c;
        if (typeof this.coverageForDomesticShipments !== "boolean")
            errors.push("Wrong flag coverage for domestic shipments");
        const { conveyanceSizeAndLimits } = this;
        if (!((_a = conveyanceSizeAndLimits === null || conveyanceSizeAndLimits === void 0 ? void 0 : conveyanceSizeAndLimits.oneShipment) === null || _a === void 0 ? void 0 : _a.averageValue) ||
            !((_b = conveyanceSizeAndLimits === null || conveyanceSizeAndLimits === void 0 ? void 0 : conveyanceSizeAndLimits.oneShipment) === null || _b === void 0 ? void 0 : _b.desiredLimit) ||
            !((_c = conveyanceSizeAndLimits === null || conveyanceSizeAndLimits === void 0 ? void 0 : conveyanceSizeAndLimits.oneShipment) === null || _c === void 0 ? void 0 : _c.maximumValue)) {
            errors.push("Wrong conveyance size and limits (One Shipment)");
        }
        return errors;
    }
    validate({ hasPreviousPolicy }) {
        let errors = [];
        const { primaryCommodity, secondaryCommodities, goodsInsuredDescription, allGoodsBeContainerized, targetPremium, currentDeductible, maximumDesiredCoverageLimit, isTemperatureSensitive, temperatureDesiredCoverage, coverageForDomesticShipments, primaryDomesticShipment, contingentDomesticShipment, primaryInternationalShipment, contingentInternationalShipment, totalInternationalShipment } = this;
        if (!primaryCommodity ||
            !utils_1.isString(primaryCommodity))
            errors.push("Wrong primary commodity");
        if (!secondaryCommodities ||
            !utils_1.isArrayOfStrings(secondaryCommodities) ||
            secondaryCommodities.length === 0)
            errors.push("Wrong secondary commodities");
        if (!goodsInsuredDescription)
            errors.push("Wrong goods insured description");
        errors = this.validateExhibitionCoverage(errors);
        if (typeof this.isTemperatureSensitive !== "boolean")
            errors.push("Wrong flag is temperature sensitive");
        if (isTemperatureSensitive && !temperatureDesiredCoverage)
            errors.push("Wrong temperature desired coverage");
        if (primaryDomesticShipment === null && coverageForDomesticShipments)
            errors.push("Primary Domestic Shipment required");
        if (contingentDomesticShipment === null && coverageForDomesticShipments)
            errors.push("Contingent Domestic Shipment required");
        if (primaryInternationalShipment === null)
            errors.push("Primary International Shipment required");
        if (contingentInternationalShipment === null)
            errors.push("Contingent International Shipment required");
        if (totalInternationalShipment !== null && (totalInternationalShipment < 0 || totalInternationalShipment > 100))
            errors.push("Wrong percentage of Total International shipment");
        if (typeof allGoodsBeContainerized !== "boolean")
            errors.push("Wrong flag is all goods be containerized");
        errors = this.validateValuation(errors);
        if (targetPremium && targetPremium < 0)
            errors.push("Wrong target premium");
        errors = this.validateDomesticCoverage(errors);
        if (hasPreviousPolicy && !currentDeductible)
            errors.push("Wrong current deductible");
        if (!utils_1.isNumber(maximumDesiredCoverageLimit)) {
            errors.push("Wrong maximum desired coverage limit");
        }
        return errors;
    }
}
exports.default = Exposure;
//# sourceMappingURL=exposures.class.js.map